module.exports = __webpack_public_path__ + "static/media/filter.f06ad34c.svg";